import { Observable } from "rxjs";
import { ApiService } from "../api.service";

export class OrderSearch {
  constructor(private _api: ApiService) { }

  public RunManualOrderSearch(query: string): Observable<any[]> {
    return this._api.Get<any[]>('RunManualOrderSearch', {
      Query: query,
    });
  }

  public RunAISearch(query: string): Observable<any[]> {
    return this._api.Get<any[]>('RunAISearch', {
      Query: query,
    });
  }

}